import {type Props} from '#/components/icons/common'
import {VerifiedCheck} from '#/components/icons/VerifiedCheck'
import {VerifierCheck} from '#/components/icons/VerifierCheck'

/** SHXRE verified: individual = blue badge, business = gold badge. */
export type VerifiedBadgeVariant = 'individual' | 'business'

const GOLD_BADGE_FILL = '#E7B53B'

export function VerificationCheck({
  verifier,
  badgeVariant,
  fill: fillProp,
  ...rest
}: Props & {
  verifier?: boolean
  /** SHXRE verified type: business = gold; individual uses fill from parent (blue) */
  badgeVariant?: VerifiedBadgeVariant
}) {
  const fill =
    badgeVariant === 'business' ? GOLD_BADGE_FILL : fillProp
  if (verifier) {
    return <VerifierCheck {...rest} fill={fillProp} />
  }
  return <VerifiedCheck {...rest} fill={fill} />
}
